import { render, staticRenderFns } from "./CartIconSvg.vue?vue&type=template&id=677f4efc&"
import script from "./CartIconSvg.vue?vue&type=script&lang=js&"
export * from "./CartIconSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports